import { useEffect, useState } from 'react';
import Image from 'next/image';
import styles from '../styles/ChatbotWidget.module.css';
import * as cookieHelper from '../lib/cookieHelper';
import { isAiChatEnabled, isUserLoggedIn } from '../lib/chatbotAuth';
import * as LIB from '../lib/common';

const ChatbotWidget = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    // Show only when logged in and session zd_aichat is enabled.
    // Read from reload_session response body first (cookie may lag / be missing).
    const updateVisibility = async () => {
      let enabled = false;

      if (process.env.runningEnv !== 'local') {
        enabled = await cookieHelper.fetchAiChatEnabled();
      } else {
        // local: still try server payload, then fall back to cookie
        try {
          enabled = await cookieHelper.fetchAiChatEnabled();
        } catch (e) {
          enabled = isAiChatEnabled();
        }
      }

      setVisible(isUserLoggedIn() && enabled);
    };

    updateVisibility();

    const handleSignIn = async () => {
      await updateVisibility();
    };

    const handleSignOut = () => {
      setVisible(false);
    };

    document.addEventListener('signin', handleSignIn);
    document.addEventListener('signoff', handleSignOut);

    return () => {
      document.removeEventListener('signin', handleSignIn);
      document.removeEventListener('signoff', handleSignOut);
    };
  }, []);

  const openChatbotPage = () => {
    // open chatbot page in a new tab
    window.open(LIB.getBasepath('/chatbot'), '_blank');
  };

  // if not allowed, don't show the chatbot widget
  if (!visible) {
    return null;
  }

  // if logged in + zd_aichat enabled, show the chatbot widget
  return (
    <div className={styles.fab}>
      <button
        type="button"
        className={styles.fabButton}
        onClick={openChatbotPage}
        title="日報小編 AI"
      >
        <Image
          src={LIB.getBasepath('/images/home/ai_icon.png')}
          height={90}
          width={90}
          alt="ai feature icon"
        />
      </button>
    </div>
  );
};

export default ChatbotWidget;
